/**
 * Possible weights of a damage report
 */
export enum DamageReportDamageWeightEnum {
    LIGHT = 1,
    MEDIUM = 2,
    HEAVY = 3,
    TOTAL = 4
}